import PageHeader from "@/components/common/PageHeader";
import { ProfiloCard, SicurezzaCard } from "@/components/settings/IlTuoAccesso";

/**
 * «Il tuo accesso», per ogni ruolo (`/sicurezza`, dal menu col nome).
 *
 * Decisione del 25-09: il venditore attiva o toglie il suo codice di verifica da una pagina sua, senza aprire le
 * Impostazioni (che per lui restano chiuse). Dal blocco 4 del redesign la pagina porta anche il Profilo, e nelle
 * Impostazioni le stesse due schede stanno nel gruppo «Il tuo accesso». Per il titolare il codice è obbligatorio:
 * se lo sposta, il cancello di `ProtectedRoute` gli chiede subito di collegare il telefono nuovo.
 */
export default function SicurezzaPage() {
  return (
    <section className="space-y-section" data-testid="page-sicurezza">
      <PageHeader
        title="Il tuo accesso"
        description="Chi sei nel gestionale e come ci entri: il profilo e il codice di verifica."
      />
      <ProfiloCard />
      <SicurezzaCard />
    </section>
  );
}
